/* Expiring private test of automatic pricing, scoped to the unlisted duplicate. */
window.EtPdpTestOffer = Object.freeze({
  productId:10612481229066,
  expiresAt:'2026-09-08T19:30:00Z'
});
